import React from 'react'
import { Alert, } from 'reactstrap'
import { Link, } from 'react-router-dom'
import timestamper from '../../helpers/timestamper'


/* 
  Invites

  <InvitesMessageBar
    isFetchingInvitation={this.props.isFetchingInvitation}
    isFetchingInvitationError={this.props.isFetchingInvitationError}
    isSavingError={this.props.isSavingError}
    invitation={this.props.invitation}
  />
*/

export default function InvitesMessageBar({isFetchingInvitation, isFetchingInvitationError, isSavingError, invitation, isStudent}) {
  let componentToRender = null
  if (isFetchingInvitationError) {
    let errorMessage = (
      `Error loading invitation. Check the link in your email, 
      and if this issue persists, please ask your administrator 
      to re-send or contact customer support.`
    )
    if (isFetchingInvitationError === 'Invite not found') {
      errorMessage = (
        `Invite not found. Check the link in your email, and 
        if this issue persists, please ask your administrator 
        to re-send or contact customer support.`
      )
    }
    componentToRender = <Alert color='danger'>{errorMessage}</Alert>
  } else if (isFetchingInvitation) {
    componentToRender = <Alert color='secondary'><i className="fa fa-spinner fa-lg fa-spin"></i> Loading...</Alert>
  }

  if (isSavingError) {
    const errorMessage = (
      `Error saving your registration. Please check your internet
      connection and try again. If this issue persists, please 
      contact customer support.`
    )
    componentToRender = <Alert color='danger'>{errorMessage}</Alert>
  }

  const time = timestamper()

  if (invitation) {
    if (invitation.expirationDate < time) {
      const errorMessage = (
        `This invitation has expired. For security reasons, invitations
        expire after three days. Please ask your administrator to re-send 
        the invitation, or contact customer support.`
      )
      componentToRender = <Alert color='danger'>{errorMessage}</Alert>
    }
  
    if (invitation.complete) {
      let query = ''
      if (!isStudent) {
        query = `?gua=${invitation.userId}`
      }
      const errorAlert = (
        <Alert color='warning'>
          You have already completed your registration. Click here to
          &nbsp;<Link to={`/assessment/dashboard/6e60eb20-172e-11e8-8bfb-cb0010808928${query}`}>log in</Link>. If you have forgotten your password or have not created one,
          click "Forgot password?" at the log-in menu.
        </Alert>
      )
      componentToRender = errorAlert
    }
  }


  return (
    componentToRender
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/InvitesMessageBar.js